import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useUserType } from './UserTypeContext';

// My components
import { LoginForm } from "../../components/common/LoginForm";

// My css
import loginCss from "../../css/common/login-page.module.css";

import logo from "../../assets/images/Thalir-loging-page.png";
import yuva1 from "../../assets/images/yuva1.png";
import yuva2 from "../../assets/images/yuva2.png";
import yuva3 from "../../assets/images/yuva3.png";
import yuva4 from "../../assets/images/yuva4.png";
import { SERVER_ORIGIN } from "../../utilities/constants";

const ThalirLoginPage = () => {
    const { userType, setUserTypeToAdmin, setUserTypeToUser, setUserTypeToInstitute, setUserTypeToChapterEM, setUserTypeToRegionEM } = useUserType();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [creds, setCreds] = useState({});
    const [selectedUserType, setSelectedUserType] = useState("");
    const [showWelcome, setShowWelcome] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        let typeParam = urlParams.get('userType');

        if (typeParam === 'admin') {
            setUserTypeToAdmin()
            if (sessionStorage.getItem("token")) {
                navigate("/admin/services")
            }
        }
        if (typeParam === 'student') {
            setUserTypeToUser()
            if (sessionStorage.getItem("token")) {
                navigate("/")
            }
        }
        if (typeParam === 'institute') {
            setUserTypeToInstitute()
            if (sessionStorage.getItem("token")) {
                navigate("/institute/services")
            }
        }
        if (typeParam === 'em') {
            setUserTypeToChapterEM()
            if (sessionStorage.getItem("token")) {
                navigate("/em/services")
            }
        }
        if (typeParam === 'regionem') {
            setUserTypeToRegionEM()
            if (sessionStorage.getItem("token")) {
                navigate("/admin/services")
            }
        }

        if (userType === "student") {
            setCreds({ userId: "", password: "" });
        } else if (userType === "institute") {
            setCreds({ instituteEmail: "", password: "" });
        } else if (userType === "em") {
            setCreds({ email: "", password: "" });
        } else if (userType === "regionem") {
            setCreds({ email: "", password: "" });
        }

        setSelectedUserType(typeParam || "");
        setShowWelcome(!(!!typeParam));

    }, [location.search, userType, navigate, setUserTypeToAdmin, setUserTypeToUser, setUserTypeToInstitute, setUserTypeToChapterEM, setUserTypeToRegionEM]);

    const handleSubmit = async () => {
        setIsLoading(true);
        let URLname;
        if (userType === "student") { setCreds({ "userId": "", password: "" }); URLname = "student"; }
        else if (userType === "institute") { setCreds({ "officerEmail": "", password: "" }); URLname = "institute"; }
        else if (userType === "em") { setCreds({ "email": "", password: "" }); URLname = "em"; }
        else if (userType === "regionem") { setCreds({ "email": "", password: "" }); URLname = "regionem"; }

        try {
            const instituteId = process.env.REACT_APP_INSTITUTE_ID;
            const institutePassword = process.env.REACT_APP_INSTITUTE_PASSWORD;
            const basicAuth = btoa(`${instituteId}:${institutePassword}`);
            const response = await fetch(
                `${SERVER_ORIGIN}/api/${URLname}/auth/login?portalType=${window.location.pathname.includes("thalir-login") ? "thalir" : "yuva"
                }`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Basic ${basicAuth}`,
                    },
                    body: JSON.stringify(creds),
                }
            );

            setIsLoading(false);
            const result = await response.json();

            if (response.status >= 400 && response.status < 600) {
                if (response.status === 401) {
                    if (
                        !("areCredsInvalid" in result) ||
                        result.areCredsInvalid === true
                    ) {
                        toast.error(result.statusText);
                    }
                } else {
                    toast.error(result.statusText);
                }
            } else if (response.ok && response.status === 200) {
                if ("token" in result) {
                    console.log("result:",result);
                    const token = result.token;
                    const mongo_id = result._id._id
                    sessionStorage.setItem("token", token);
                    sessionStorage.setItem('_id', mongo_id);
                    sessionStorage.setItem('mouType',result._id.moutype);


                    // Store user role for Region EM users
                    if (userType === 'regionem' && result._id.role) {
                        sessionStorage.setItem('userRole', result._id.role);
                        sessionStorage.setItem('region', result._id.region);
                        sessionStorage.setItem('regionEMfor', result._id.regionEMfor);

                    }

                    // Route all users to admin dashboard
                    if (userType === 'regionem' || userType === 'admin') {
                        navigate('/admin/services');
                    } else {
                        navigate(`/${userType}/services`);
                    }
                }
            } else {
                // for future
            }
        } catch (error) {
            setIsLoading(false);
            toast.error("An error occurred. Please try again.");
        }
    };

    const updateCreds = (e) => {
        setCreds((prevCreds) => {
            const newCreds = { ...prevCreds, [e.target.name]: e.target.value };
            return newCreds;
        });
    };

    const handleUserTypeSelect = (type) => {
        setSelectedUserType(type);
        setShowWelcome(false);
        navigate(`/thalir-login?userType=${type}`, { replace: true });

        // Set user type in context
        switch (type) {
            case 'student':
                setUserTypeToUser();
                break;
            case 'institute':
                setUserTypeToInstitute();
                break;
            case 'em':
                setUserTypeToChapterEM();
                break;
            case 'regionem':
                setUserTypeToRegionEM();
                break;
            case 'admin':
                setUserTypeToAdmin();
                break;
            default:
                break;
        }
    };

    const userTypeCards = [
        // {
        //     type: "student",
        //     label: "Student",
        //     description: "Login as Student",
        //     icon: yuva1,
        // },
        {
            type: "institute",
            label: "School Login",
            description: "Login as School",
            icon: yuva2,
        },
        {
            type: "em",
            label: "Chapter EM",
            description: "Login as Chapter EM",
            icon: yuva3,
        },
        {
            type: "regionem",
            label: "Regional Mentor",
            description: "Login as Regional Mentor",
            icon: yuva4,
        }
    ];

    return (
        <>
            {!sessionStorage.getItem("token") && (
                <div className={loginCss.outerDiv}>
                    {showWelcome ? (
                        <>
                            <img
                                src={logo}
                                alt="thalir-big-logo"
                                className={loginCss.yuvaImg}
                            />
                            {/* User Type Selection */}
                            <div style={{ marginBottom: '2rem' }}>
                                <h3 style={{
                                    textAlign: 'center',
                                    marginBottom: '1.5rem',
                                    color: 'var(--yuva-blue)',
                                    fontSize: '1.5rem'
                                }}>
                                    Welcome Back!
                                </h3>
                                <p style={{ textAlign: 'center', color: '#666', marginTop: '-1rem', marginBottom: '1.5rem' }}>
                                    Sign in to continue to Thalir - Let's Nurture From School
                                </p>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                                    gap: '1rem',
                                    marginBottom: '2rem'
                                }}>
                                    {userTypeCards.map((card) => (
                                        <div
                                            key={card.type}
                                            onClick={() => handleUserTypeSelect(card.type)}
                                            style={{
                                                padding: '1rem',
                                                border: selectedUserType === card.type ? '2px solid var(--yuva-blue)' : '1px solid #ddd',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                backgroundColor: selectedUserType === card.type ? '#f0f8ff' : '#fff',
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            <img src={card.icon} alt={card.label} style={{ width: '56px', height: '56px', objectFit: 'contain', marginBottom: '0.5rem' }} />
                                            <h6 style={{ margin: '0', color: 'var(--yuva-blue)', fontWeight: 600 }}>
                                                {card.label}
                                            </h6>
                                        </div>
                                    ))}
                                </div>
                                {/* Login as admin link - WITH THIN BORDER */}
                                <div style={{
                                    textAlign: 'center',
                                    marginTop: '1.5rem',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '0.5rem',

                                }}>
                                    <div style={{
                                        padding: '0.5rem 1rem',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        backgroundColor: '#ffff'
                                    }}>
                                        <p style={{ margin: '0', color: '#666', fontSize: '0.9rem' }}>
                                            Login as admin -
                                        </p>
                                        <span
                                            onClick={() => navigate('/admin/login')}
                                            style={{
                                                color: 'var(--yuva-blue)',
                                                cursor: 'pointer',
                                                fontWeight: '600',
                                                fontSize: '0.9rem',
                                                textDecoration: 'underline'
                                            }}
                                        >
                                            LOGIN NOW
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <img
                                src={logo}
                                alt="thalir-big-logo"
                                className={loginCss.yuvaImg}
                            />
                            {/* Right side content replacing userTypeCards */}
                            <div style={{ marginBottom: '2rem' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                    <h3 style={{
                                        margin: 0,
                                        color: 'var(--yuva-blue)',
                                        fontSize: '1.8rem',
                                        fontWeight: 600
                                    }}>
                                        {userType === 'regionem' ? 'Regional Mentor' : userType === 'em' ? 'Chapter EM' : userType === 'institute' ? 'School Login' : 'Student'}
                                    </h3>
                                    <button onClick={() => { setShowWelcome(true); setSelectedUserType(""); navigate('/thalir-login', { replace: true }); }} style={{ border: 'none', background: 'transparent', color: '#666', cursor: 'pointer' }}>
                                        ← Back
                                    </button>
                                </div>

                                <LoginForm
                                    role={userType === "student" ? "user" : userType}
                                    adminId={creds[userType] === "student" ? "user" : creds[userType]}
                                    password={creds.password}
                                    onChange={updateCreds}
                                    onClick={handleSubmit}
                                    isBtnDisabled={isLoading}
                                />
                            </div>
                        </>
                    )}
                </div>
            )}
        </>
    );
};

export default ThalirLoginPage;
